"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationInitializerDefinition = void 0;
const WidgetInitializerPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPlugin");
const WidgetInitializerPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetInitializer/WidgetInitializerPluginDefinition");
const RepositoryTypes_1 = require("../../../../Enum/RepositoryTypes");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const EndpointError_1 = require("../../../../Error/EndpointError");
const ValuationNotFoundError_1 = require("../../../../Error/ValuationNotFoundError");
/**
 * Initializes valuation in case of existing token.
 */
class ValuationInitializer extends WidgetInitializerPlugin_1.default {
    constructor(definition, repositoryFactory, valuationTransformer) {
        super(definition);
        this.repositoryFactory = repositoryFactory;
        this.transformer = valuationTransformer;
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition, container.get('factory.repository'), container.get('transformer.valuation_to_data'));
    }
    /**
     * @inheritDoc
     */
    initialize(config, state) {
        const valuatioRepo = this.repositoryFactory.create(RepositoryTypes_1.RepositoryTypes.VALUATION, { config });
        if (config.getValuation()) {
            state.setValuation(this.transformer.from(config.getValuation()));
            return Promise.resolve();
        }
        return valuatioRepo.get(config.getToken())
            .then((valuation) => {
            state.setValuation(valuation);
        })
            .catch((error) => {
            if (EndpointError_1.default.is(error) && error.getResponseStatus() === 404) {
                throw new ValuationNotFoundError_1.default(config.getToken());
            }
            throw error;
        });
    }
}
exports.default = ValuationInitializer;
exports.ValuationInitializerDefinition = new WidgetInitializerPluginDefinition_1.default({
    id: "valuation_initializer",
    class: ValuationInitializer,
    priority: 50
});
Mixin_1.default(ValuationInitializer, IContainerInjection_1.default);
